module.exports = __webpack_public_path__ + "img/card-small-b8.dc931719.png";